import React from "react";
import PropTypes from "prop-types";
import {
  Select,
  Form,
  FormGroup,
  Input,
  Button,
  ModalView,
  Row,
  Col,
  Fade,
  Error,
  FormFeedback
} from "../../simple";
import SVG from "../../SVG";
import {
  DropdownIndicator,
  EmptyIndicatorSeparator as IndicatorSeparator,
  UserRoleOption
} from "../../../helpers/select/components";
import { userRoleStyles } from "../../../helpers/select/styles/index";

import "../../../styles/components/invite-form.scss";

const options = userRole => {
  return userRole === "admin" || userRole === "gdr admin"
    ? [
        {
          label: "Admin",
          addition: "Unlimited access",
          value: "admin"
        },
        {
          label: "Can Create & Push",
          addition: "Access to push",
          value: "user"
        }
      ]
    : [
        {
          label: "Can Create & Push",
          addition: "Access to push",
          value: "user"
        }
      ];
};

export default class InviteForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      emails: [""],
      message: "",
      role: ""
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleEmail = this.handleEmail.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.addEmail = this.addEmail.bind(this);
  }

  handleChange(name, value) {
    this.props.setError("");
    this.setState({
      [name]: value
    });
  }

  handleEmail(idx, value) {
    this.props.setError("");
    const { emails } = this.state;
    const newEmails = [...emails];
    newEmails.splice(idx, 1, value);
    this.setState({ emails: [...newEmails] });
  }

  addEmail() {
    this.setState(({ emails }) => ({ emails: [...emails, ""] }));
  }

  handleSubmit(evt) {
    evt.preventDefault();
    this.props.handleSubmit({ ...this.state });
  }

  render() {
    const { message, emails, role } = this.state;
    const { user } = this.props;

    return (
      <Form onSubmit={this.handleSubmit} className="invite-form">
        <h2 className="title">Invite people to team</h2>
        <FormGroup>
          <Row>
            <Col lg={6} md={6} sm={6}>
              <Select
                label="Can create"
                containerClass="filter-created"
                isSearchable={false}
                value={role}
                placeholder="Can create"
                options={options(user?.role)}
                name="role"
                styles={userRoleStyles}
                components={{
                  DropdownIndicator,
                  IndicatorSeparator,
                  Option: UserRoleOption
                }}
                handleChange={this.handleChange}
              />
            </Col>
          </Row>
          {emails.map((value, idx) => (
            <Input
              // eslint-disable-next-line react/no-array-index-key
              key={`email-${idx}`}
              type="email"
              value={value}
              label="Email"
              name={idx}
              placeholder="Email"
              handleChange={this.handleEmail}
            />
          ))}
          <Button className="add-email-button" onClick={this.addEmail}>
            <SVG.Plus className="icon" width={16} height={16} />
            <span>Add Email address</span>
          </Button>
          <Input
            type="textarea"
            value={message}
            label="Add a message (optional)"
            name="message"
            placeholder="Add a message (optional)"
            handleChange={this.handleChange}
          />
          <Fade in={!!this.props.error} tag="div" className="form-error">
            <Error component={FormFeedback} error={this.props.error} />
          </Fade>
        </FormGroup>
        <Button
          type="submit"
          className="button"
          style={{ minWidth: "133px", justifyContent: "center" }}
        >
          Send
        </Button>
      </Form>
    );
  }
}

InviteForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  setError: PropTypes.func,
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.shape({})
  ]),
  user: PropTypes.shape({ role: PropTypes.string }).isRequired
};

InviteForm.defaultProps = {
  setError: () => null,
  error: ""
};

export function InviteFormModal(props) {
  const { isOpen, goBackAction, ...formProps } = props;

  return (
    <ModalView isOpen={isOpen} handleClose={goBackAction}>
      <InviteForm {...formProps} />
    </ModalView>
  );
}

InviteFormModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  goBackAction: PropTypes.func.isRequired
};
